<template>
  <div id="index" ref="appRef">
    <div class="bg">
      <dv-loading v-if="loading">Loading...</dv-loading>
      <div v-else class="host-body">
        <div class="left-side-icon" @click="showMenu" @mouseover="showMenu"></div>

        <!-- 左侧菜单 -->
        <div class="left-side-menu" v-if="isShowMenu" @click="hideMenu" @mouseleave="hideMenu">
          <div class="menu-list" :class="item.id ==isActive?'menu-active':''" v-for="(item,index) in menuList" :key="index" @click="menuChange(item,index)">
            <span>{{item.name}}</span>
          </div>

        </div>

        <div class="d-flex jc-between mg-top">
          <div class="d-flex aside-width">
            <div class="react-left mr-4 react-l-s">
              <!-- <span class="react-before"></span> -->
              <span class="text">{{ dateYear }} {{ dateWeek }} {{ dateDay }}</span>
            </div>
            <div class="react-left bg-color-blue mr-3">
              <span class="text"></span>
            </div>
          </div>
          <div class="show-title">
            <div class="ft-size">平高智联充电运营大数据平台</div>
          </div>
          <div class="d-flex aside-width" style="justify-content: space-between;">
            <div class="d-flex">
              <div class="react-left bg-color-blue mr-4 trf-sk-1">
                <span class="text"></span>
              </div>
              <div class="react-left react-l-s trf-sk-2">
                <span style="display: inline-block; transform: skewX(55deg); position:absolute;top:6px;right:32px"><img width="24px" height="24px" src="../../assets/loginout-2.png" @click="loginOut" /></span>
              </div>
            </div>
            <div><img src="../../assets/loginout-2.png" /></div>
          </div>
        </div>
        <!-- 第二行 -->
        <div class="d-flex flex mg-top mg-position">
          <dv-decoration-10 class="dv-dec-10" />
          <div class="d-flex dv-40">
            <dv-decoration-8 class="dv-dec-8" :color="['#568aea', '#030D45']" />
            <dv-decoration-6 class="dv-dec-6 dv-6-size" :color="['#50e3c2', '#67a1e5']" />
            <dv-decoration-6 class="dv-dec-6 dv-6-size" :reverse="true" :color="['#50e3c2', '#67a1e5']" />
            <dv-decoration-8 class="dv-dec-8" :reverse="true" :color="['#568aea', '#030D45']" />
          </div>
          <dv-decoration-10 class="dv-dec-10-s" />
        </div>

        <!-- 第三行 -->
        <div class="body-box">
          <div class="content-grid">
            <!-- 左边 -->
            <div>
              <left1 ref="left1" :level="level" :regionId="selectedRegionId" :deviceType="selectedDevType"></left1>
              <left2 ref="left2" :level="level" :regionId="selectedRegionId" :deviceType="selectedDevType"></left2>
              <left3 ref="left3" :level="level" :regionId="selectedRegionId" :deviceType="selectedDevType"></left3>
            </div>
            <!-- 中间 -->
            <div class="mid-b-box">
              <div class="btn-box province-box" @click="provinceListShow">
                {{selectedProvinceName}}
                <i style="margin:0 5px" :class="isProvinceListShow?'el-icon-caret-top':'el-icon-caret-bottom'"></i>
              </div>
              <ul class="province-list" v-if="isProvinceListShow">
                <li v-for="(item,index) in provinceList" :key="index" :class="item.isSelected?'selected':''" @click="selectProvince(item)">
                  {{item.name}}
                </li>
              </ul>
              <!-- 设备类型 -->
              <div class="btn-box devTypeBox" @click="devTypeListShow">
                {{selectedDevTypeName}}
                <i style="margin:0 5px" :class="isDevTypeListShow?'el-icon-caret-top':'el-icon-caret-bottom'"></i>
              </div>
              <ul class="devType-list" v-if="isDevTypeListShow">
                <li v-for="(item,index) in devTypeList" :key="index" :class="item.isSelected?'selected':''" @click="selectDevType(item)">
                  {{item.name}}
                </li>
              </ul>
              <center1 ref="center1" :level="level" :regionId="selectedRegionId" :deviceType="selectedDevType"></center1>
              <chinaMap ref="chinaMap" :level="level" :regionId="selectedRegionId" :deviceType="selectedDevType" :chooseproviceName="selectedProvinceName" @clearChoose="clearChoose" @fillChoose="fillChoose"></chinaMap>
              <center3></center3>
            </div>
            <!-- 右边 -->
            <div>
              <right1 ref="right1" :level="level" :regionId="selectedRegionId" :deviceType="selectedDevType"></right1>
              <right2 ref="right2" :level="level" :regionId="selectedRegionId" :deviceType="selectedDevType"></right2>
              <right3 ref="right3" :level="level" :regionId="selectedRegionId" :deviceType="selectedDevType"></right3>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import drawMixin from "../../utils/drawMixin";
import { formatTime } from "../../utils/index.js";
import left1 from "./left-1";
import left2 from "./left-2";
import left3 from "./left-3";

import center1 from "./center-1";
import chinaMap from "../Map/china.vue";
import center3 from "./center-3";

import right1 from "./right-1";
import right2 from "./right-2";
import right3 from "./right-3";

export default {
  mixins: [drawMixin],
  data() {
    return {
      timing: null,
      loading: true,
      dateDay: null,
      dateYear: null,
      dateWeek: null,
      weekday: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
      isShowMenu: false,
      isActive: 1,
      menuList: [
        {
          name: "充电运营大数据平台",
          id: 1,
        },
        {
          name: "电动自行车管理系统",
          id: 2,
        },
        {
          name: "电动汽车管理系统",
          id: 3,
        },
        {
          name: "设备监管系统",
          id: 4,
        },
        {
          name: "换电管理系统",
          id: 5,
        },
        {
          name: "源网荷储系统",
          id: 6,
        },
        {
          name: "数据分析系统",
          id: 7,
        },
      ],

      isProvinceListShow: false,
      selectedProvinceName: "全国",
      selectedRegionId: "",
      selectedDevTypeName: "总览",
      isDevTypeListShow: false,
      devTypeList: [
        {
          devType: "",
          name: "总览",
          isSelected: true,
        },
        {
          devType: "0",
          name: "电动自行车",
          isSelected: false,
        },
        {
          devType: "1",
          name: "电动汽车",
          isSelected: false,
        },
      ],
      selectedDevType: "",
      level: 0, //0 全国 1 省
      provinceList: [],
    };
  },
  components: {
    left1,
    left2,
    left3,
    center1,
    chinaMap,
    center3,
    right1,
    right2,
    right3,
  },
  mounted() {
    this.timeFn();
    this.cancelLoading();
    this.getProvinceList();
  },
  beforeDestroy() {
    clearInterval(this.timing);
  },
  methods: {
    // 获取省份
    async getProvinceList() {
      const { data: res } = await this.$http.get(
        "/admin/api/realTime/getRegionByProvince"
      );
      this.provinceList = res.data;
      // 每一项，加入 是否选中的属性
      this.provinceList.map((item) => {
        item.isSelected = false;
        // item.name = item.name
      });
      // 加入全国
      this.provinceList.unshift({
        name: "全国",
        id: 0,
        isSelected: true,
      });
      console.log("全国省份", this.provinceList);
    },
    showMenu() {
      this.isShowMenu = true;
    },
    hideMenu() {
      this.isShowMenu = false;
    },
    menuChange(item, index) {
      this.isActive = item.id;
      if (item.id == 2) {
        this.$router.push({
          path: "/bicycleSystem",
          query: {
            currentMenu: item.id,
          },
        });
      } else if (item.id == 3) {
        this.$router.push({
          path: "/carSystem",
          query: {
            currentMenu: item.id,
          },
        });
      }
    },
    clearChoose(obj){
      if(obj.regionId==''){
        this.level = 0;
        this.selectedProvinceName = '全国'
      }
    },
    fillChoose(obj){
      this.selectedRegionId = obj.regionId;
      this.selectedProvinceName = obj.name;
      this.level = obj.level;
      this.$nextTick(() => {
        this.$refs.left1.getTopSellerData();
        this.$refs.left1.getTopSocketData();
        this.$refs.left2.getData();
        this.$refs.left3.getRealTimeChargingGroupInfo();
        this.$refs.center1.getData();
        // this.$refs.chinaMap.getData();
        // this.$refs.chinaMap.parentChoose();
        this.$refs.right1.getData();
        this.$refs.right2.getData();
        this.$refs.right3.getData();
      });
    },
    
    // 是 全国 还是 各省 的下拉选择
    provinceListShow() {
      this.isProvinceListShow = !this.isProvinceListShow;
      this.isDevTypeListShow = false;
    },
    // 选择省
    selectProvince(item) {
      item.isSelected = true;
      this.selectedRegionId = item.id;
      if (item.name == "全国") {
        this.level = 0;
        this.selectedRegionId = '';
      } else {
        this.level = 1;
      }
      this.isProvinceListShow = false;
      this.selectedProvinceName = item.name;
      // 父组件的值发生变化，主动调用子组件的函数，重新获取数据
      this.$nextTick(() => {
        this.$refs.left1.getTopSellerData();
        this.$refs.left1.getTopSocketData();
        this.$refs.left2.getData();
        this.$refs.left3.getRealTimeChargingGroupInfo();
        this.$refs.center1.getData();
        this.$refs.chinaMap.getData();
        this.$refs.chinaMap.parentChoose();
        this.$refs.right1.getData();
        this.$refs.right2.getData();
        this.$refs.right3.getData();
      });
      this.provinceList.map((province) => {
        if (province.id != item.id) {
          province.isSelected = false;
        }
      });
    },
    // 选择 设备类型
    devTypeListShow() {
      // debugger;
      this.isDevTypeListShow = !this.isDevTypeListShow;
      this.isProvinceListShow = false;
    },
    selectDevType(item) {
      item.isSelected = true;
      this.selectedDevType = item.devType;
      this.isDevTypeListShow = false;
      this.selectedDevTypeName = item.name;
      // 父组件的值发生变化，主动调用子组件的函数，重新获取数据
      this.$nextTick(() => {
        this.$refs.left1.getTopSellerData();
        this.$refs.left1.getTopSocketData();
        this.$refs.left2.getData();
        this.$refs.left3.getRealTimeChargingGroupInfo();
        this.$refs.center1.getData();
        this.$refs.chinaMap.getData();
        // this.$refs.chinaMap.parentChoose();
        this.$refs.right1.getData();
        this.$refs.right2.getData();
        this.$refs.right3.getData();
      });
      return this.devTypeList.map((devType) => {
        if (devType.devType != item.devType) {
          devType.isSelected = false;
        }
      });
    },
    timeFn() {
      this.timing = setInterval(() => {
        this.dateDay = formatTime(new Date(), "HH: mm: ss");
        this.dateYear = formatTime(new Date(), "yyyy-MM-dd");
        this.dateWeek = this.weekday[new Date().getDay()];
      }, 1000);
    },
    cancelLoading() {
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },
    // 退出登录
    loginOut() {
      this.$cookie.set("merchantId", "");
      this.$cookie.set("Authorization", "");
      this.$router.replace({ name: "login" });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/index.scss";
.mid-b-box {
  position: relative;
  .btn-box {
    // width: 120px;
    padding: 0 5px 0 15px;
    height: 30px;
    border: 1px solid #0096ff;
    border-radius: 20px;
    text-align: center;
    line-height: 30px;
    color: #fff;
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .province-box {
    position: absolute;
    left: 30px;
    top: 8px;
    width: 100px;
  }
  .province-list {
    height: 200px;
    position: absolute;
    left: 30px;
    top: 40px;
    overflow-x: scroll;
    width: 100px;
    z-index: 90
  }
  .devTypeBox {
    position: absolute;
    left: 30px;
    top: 50px;
    width: 100px;
  }
  .devType-list {
    position: absolute;
    left: 30px;
    top: 85px;
    width: 100px;
  }
  ul {
    background: rgba(10, 31, 116, 0.89);
    box-shadow: 0px 0px 3px 0px rgba(0, 150, 255, 0.6);
    border-radius: 10px;
    border-image: linear-gradient(
        180deg,
        rgba(107, 212, 250, 1),
        rgba(0, 87, 194, 1)
      )
      1 1;
    padding: 15px;
    li {
      margin-bottom: 10px;
      cursor: pointer;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    li:hover {
      color: #00ecfc;
    }
    .selected {
      color: #00ecfc;
    }
    li:last-child {
      margin-bottom: 0px;
    }
  }
}
/*定义滚动条高宽及背景
 高宽分别对应横竖滚动条的尺寸*/
::-webkit-scrollbar {
  width: 5px;
  height: 5px;
  background-color: rgba(10, 31, 116, 0.89);
}
/*定义滚动条轨道
 内阴影+圆角*/
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: rgba(10, 31, 116, 0.89);
}
/*定义滑块
 内阴影+圆角*/
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #00ecfc;
}
.bg {
  width: 100%;
  height: 100%;
  padding: 16px 16px 0 16px;
  background: url("../../assets/pgzl-screen-bg.png");
  background-size: cover;
  background-position: center center;
}
.host-body {
  position: relative;
  .left-side-icon {
    width: 46px;
    height: 320px;
    background-image: url("../../assets/side-img/side-icon.png");
    background-size: 100% 100%;
    position: absolute;
    left: 0;
    top: 65px;
  }
  .left-side-menu {
    width: 445px;
    height: 880px;
    background-image: url("../../assets/side-img/side-bg.png");
    background-size: 100% 100%;
    position: fixed;
    left: 0;
    top: 150px;
    z-index: 999;
    padding: 110px 0;
    .menu-list {
      width: 260px;
      height: 60px;
      background-image: url("../../assets/side-img/side-menu-default.png");
      background-size: 100% 100%;
      text-align: center;
      line-height: 60px;
      margin-bottom: 40px;
      color: #75b8ff;
      font-size: 21px;
    }
    .menu-list:hover {
      background-image: url("../../assets/side-img/side-menu-current.png");
      background-size: 100% 100%;
      color: #ffbb00;
      font-weight: bold;
      text-shadow: 0px 2px 12px rgba(255, 187, 0, 0.44);
    }
    .menu-active {
      background-image: url("../../assets/side-img/side-menu-current.png");
      background-size: 100% 100%;
      color: #ffbb00;
      font-weight: bold;
      text-shadow: 0px 2px 12px rgba(255, 187, 0, 0.44);
    }
  }
}
.mg-top {
  margin-top: 8px;
  .dv-40 {
    width: 40%;
  }
}
.mg-position {
  position: relative;
  .title-box {
    width: 616px;
    background: linear-gradient(180deg, #b3ccff 0%, #36a3ff 100%);
    position: absolute;
    top: 0px;
    .title1 {
      font-size: 40px;
      font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
      font-weight: bold;
      color: #ffffff;
      letter-spacing: 5px;
      text-shadow: 0px 2px 8px rgba(96, 255, 249, 0.5);
      position: absolute;
      bottom: 0;
      left: 44%;
      transform: translate(-50%);
    }
    .dv-dec-6 {
      position: absolute;
      bottom: -30px;
      left: 45%;
      width: 250px;
      height: 8px;
      transform: translate(-50%);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/index/index.vue